import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from '../base/base.service';
import {Rotas} from 'src/app/core/rotas';
import {MetaObjetivo} from "../../core/metaObjetivo";

@Injectable({
    providedIn: 'root'
})

export class MetaObjetivoService extends BaseService<MetaObjetivo> {

    constructor(http: HttpClient) {
        super(http, Rotas.META_OBJETIVO);
    }

    getAllByCombo() {
        return this.http.get(`${Rotas.META_OBJETIVO}/combo`);
    }

    getComboByIdAtividade(idAcao: number) {
        return this.http.get(`${Rotas.META_OBJETIVO}combo/atividade/${idAcao}`);
    }

}
